// Fixed function declaration syntax
export function processUrlSlug(url) {
  if (!url) return { url: null, slug: null };

  const segments = url.split('/').filter(Boolean);

  // Remove numeric segments (likely IDs) and UUIDs
  const baseSegments = segments.filter(segment => {
    return !/^\d+$/.test(segment) && // Remove pure numbers
      !/^[a-f0-9-]{36}$/.test(segment); // Remove UUIDs
  });

  const baseRoute = `/${baseSegments.join('/')}`;

  // Determine context - if original URL had numeric segments, it's a detail view
  let context = null;
  const hasNumericSegments = segments.some(segment => /^\d+$/.test(segment));
  if (hasNumericSegments) {
    context = 'detail';
  }

  return baseRoute;
}

